import React from 'react'
import HeaderTitle from '../Header/HeaderTitle'
import { connect } from 'react-redux'
import {
  getProjectSheetsAndHooks,
  createWebhook,
  deleteWebhook,
  resetSuccessMessage,
  checkSheetColumns,
} from '../../store/AutomationTests/actionCreator'
import apiConfig from '../../config/apiConfig'
import {
  Grid,
  FormGroup,
  FormControlLabel,
  IconButton,
  Tooltip,
  Switch,
} from '@mui/material'
import WebhookStatusModal from './WebhookStatusModal'
import AutomationTestHelpDialog from './AutomationTestHelpDialog'
import MrtReusableTable from '../Utils/MrtReusableTable'
import { ziptieColors } from '../../config/themeConfig'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import {
  handleFireflySendEvent,
  handleFireflySendClickEvent,
} from '../Utils/FireFlyVnextHelpers'

export class AutomationTests extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      smartsheetId: '',
      automationTestHelpOpen: false,
      automationTestSheetsList: [],
      newWebhookData: {},
      rowLoading: [],
      webhookFailureOpen: false,
      webhookStatusMessage: '',
    }
    this.baseState = { ...this.state }
    this.handleAutomationTestHelpOpen =
      this.handleAutomationTestHelpOpen.bind(this)
    this.handleAutomationTestHelpClose =
      this.handleAutomationTestHelpClose.bind(this)
    this.handleSuccessClose = this.handleSuccessClose.bind(this)
    this.handleSuccessOpen = this.handleSuccessOpen.bind(this)
    this.toggleWebhook = this.toggleWebhook.bind(this)
  }

  static defaultProps = {
    userInfo: {
      email: undefined,
      lanId: undefined,
    },
  }

  async componentDidMount() {
    this.setState({ loading: true })
    const { userInfo } = this.props
    if (userInfo.email !== '') {
      handleFireflySendEvent(
        'PAGE_VIEW',
        'Automated Tests',
        'Automated Tests Page Load',
        userInfo,
      )
    }
    await this.props.getProjectSheetsAndHooks()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.webhookStatusMessage !== '' &&
      nextProps.webhookStatusMessage !== undefined &&
      nextProps.webhookStatusMessage !== 'success'
    ) {
      this.setState({
        webhookFailureOpen: true,
        webhookStatusMessage: nextProps.webhookStatusMessage,
      })
    } else if (nextProps.webhookStatusMessage === 'success') {
      this.setState({
        automationTestSheetsList: JSON.parse(
          JSON.stringify(nextProps.automationTestSheetsList),
        ),
        webhookStatusMessage: '',
      })
    } else {
      this.setState({
        automationTestSheetsList: JSON.parse(
          JSON.stringify(nextProps.automationTestSheetsList),
        ),
        rowLoading: [],
        webhookStatusMessage: '',
      })
    }
    this.setState({ loading: false })
  }

  async handleSuccessClose() {
    await this.setState({ webhookFailureOpen: false })
    this.props.resetSuccessMessage()
  }

  handleSuccessOpen() {
    this.setState({ webhookFailureOpen: true })
  }

  handleAutomationTestHelpOpen() {
    this.setState({ automationTestHelpOpen: true })
  }

  handleAutomationTestHelpClose() {
    this.setState({ automationTestHelpOpen: false })
  }

  toggleWebhook = (
    event,
    smartsheetId,
    sheetName,
    webhookId,
    user,
    rowIndex,
  ) => {
    handleFireflySendClickEvent(
      'CLICK',
      'Automated Tests',
      'Automated Tests Toggle Webhook',
      user,
    )
    if (this.state.rowLoading.includes(rowIndex) !== true) {
      const allLoadingRows = this.state.rowLoading.concat(rowIndex)
      if (event.target.value === 'false') {
        if (webhookId !== 'N/A') {
          this.props.deleteWebhook(webhookId)
        }
        const userName = user.email
          .substring(0, user.email.indexOf('@'))
          .replace('.', ' ')
        const newWebhookData = {
          callbackUrl: `${apiConfig.api.rapidUrl}/callback_test_devices`,
          name: sheetName + '|' + userName,
          smartsheetId: smartsheetId,
          enabled: true,
          webhookType: 'test automation',
        }
        this.setState({
          newWebhookData: newWebhookData,
          rowLoading: allLoadingRows,
        })
        this.props.checkSheetColumns(newWebhookData)
      } else {
        this.setState({ rowLoading: allLoadingRows })
        this.props.deleteWebhook(webhookId)
      }
    }
  }

  formatStatus = (input) => {
    let formattedStatus
    if (input === 'ENABLED') {
      formattedStatus = 'Enabled'
    } else if (input === 'NEW_NOT_VERIFIED') {
      formattedStatus = 'Not Verified'
    } else if (input === 'DISABLED_BY_OWNER') {
      formattedStatus = 'Disabled By Owner'
    } else if (input === 'DISABLED_VERIFICATION_FAILED') {
      formattedStatus = 'Verification Failed'
    } else if (input === 'DISABLED_SCOPE_INACCESSIBLE') {
      formattedStatus = 'Smartsheet Scope Not Accessible'
    } else {
      formattedStatus = 'Enable Automation'
    }
    return formattedStatus
  }

  render() {
    let projectSheets = []
    const automationTestsColumns = [
      {
        accessorKey: 'sheetName',
        header: 'Sheet Name',
        size: 400,
        Cell: ({ cell, row }) => {
          const value = cell.getValue()
          const link = row.original.permalink
          return (
            <a href={link} target="_blank" rel="noopener noreferrer">
              {value}
            </a>
          )
        },
      },
      {
        accessorKey: 'creator',
        header: 'Creator',
      },
      {
        accessorKey: 'lastSuccessfulCallback',
        header: 'Last Successful Validation',
        size: 200,
        Cell: ({ cell }) => {
          const value = cell.getValue()
          if (value === 'N/A') return 'N/A'
          const date = new Date(value)
          const formattedDate = date.toLocaleDateString()
          const hours = date.getHours()
          const minutes = date.getMinutes()
          let displayHours
          let amPm
          if (hours > 12) {
            displayHours = hours - 12
            amPm = 'PM'
          } else if (hours === 0) {
            displayHours = 12
            amPm = 'AM'
          } else {
            displayHours = hours
            amPm = 'AM'
          }
          const displayMinutes = (minutes < 10 ? '0' : '') + minutes
          return (
            formattedDate +
            ' - ' +
            displayHours +
            ':' +
            displayMinutes +
            ' ' +
            amPm
          )
        },
      },
      {
        accessorKey: 'webhookEnabled',
        header: 'Disabled/Enabled',
        Cell: ({ cell, row }) => (
          <FormGroup>
            <FormControlLabel
              control={
                <Tooltip title={this.formatStatus(row.original.webhookStatus)}>
                  <Switch
                    color="success"
                    checked={cell.getValue()}
                    value={cell.getValue()}
                    onChange={(event) => {
                      this.toggleWebhook(
                        event,
                        row.original.sheetId,
                        row.original.sheetName,
                        row.original.webhookId,
                        this.props.userInfo,
                        row.index,
                      )
                    }}
                  />
                </Tooltip>
              }
            />
          </FormGroup>
        ),
      },
      {
        accessorKey: 'webhookStatus',
        header: 'Status',
      },
      {
        accessorKey: 'webhookId',
        header: 'Webhook Id',
      },
      {
        accessorKey: 'permalink',
        header: 'Smartsheet Link',
      },
      {
        accessorKey: 'sheetId',
        header: 'Smartsheet Id',
      },
    ]

    const defaultColumns = [
      'sheetName',
      'creator',
      'lastSuccessfulCallback',
      'webhookEnabled',
    ]

    projectSheets = (
      <MrtReusableTable
        pageTitle="Automated Tests"
        columns={automationTestsColumns}
        defaultColumns={defaultColumns}
        rowData={this.props.automationTestSheetsList}
        loading={this.state.loading}
        loadingMessage="Loading Automated Tests..."
        pageSize={[10, 20, 50]}
        menuButtons={
          <Tooltip title="Help">
            <IconButton
              onClick={this.handleAutomationTestHelpOpen}
              sx={{
                color: ziptieColors.primary.contrastText,
                marginLeft: '-4px',
              }}
            >
              <HelpOutlineIcon />
            </IconButton>
          </Tooltip>
        }
      />
    )

    const automationTestsPanel = <div>{projectSheets}</div>

    return (
      <>
        <HeaderTitle title="Automated Tests" />
        <Grid
          container
          direction="row"
          spacing={8}
          justifyContent="space-evenly"
          alignItems="center"
        >
          <Grid item size={{ xs: 12 }}>
            <AutomationTestHelpDialog
              open={this.state.automationTestHelpOpen}
              handleAutomationTestHelpClose={this.handleAutomationTestHelpClose}
            />
            <WebhookStatusModal
              open={this.state.webhookFailureOpen}
              handleClose={this.handleSuccessClose}
              statusMessage={this.state.webhookStatusMessage}
            />
            {automationTestsPanel}
          </Grid>
        </Grid>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    automationTestSheetsList: state.automationTests.activeProjectsList,
    userInfo: state.auth.userInfo,
    webhookStatusMessage: state.automationTests.webhookStatusMessage,
  }
}

const mapDispatchToProps = {
  getProjectSheetsAndHooks,
  createWebhook,
  deleteWebhook,
  resetSuccessMessage,
  checkSheetColumns,
}

export default connect(mapStateToProps, mapDispatchToProps)(AutomationTests)
